/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S4_P2_LinkInputs */

const tr_hakkimizda_s4_p2_link = /** @type {(inputs: Hakkimizda_S4_P2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const en_hakkimizda_s4_p2_link = /** @type {(inputs: Hakkimizda_S4_P2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_hakkimizda_s4_p2_link = /** @type {(inputs: Hakkimizda_S4_P2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ru_hakkimizda_s4_p2_link = /** @type {(inputs: Hakkimizda_S4_P2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Hakkimizda_S4_P2_LinkInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s4_p2_link = /** @type {((inputs?: Hakkimizda_S4_P2_LinkInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S4_P2_LinkInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s4_p2_link(inputs)
	if (locale === "de") return de_hakkimizda_s4_p2_link(inputs)
	if (locale === "ru") return ru_hakkimizda_s4_p2_link(inputs)
	return tr_hakkimizda_s4_p2_link(inputs)
});